// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import UserOutlined from '/Users/zhangfq/CodeMe/kn-web-demo/node_modules/.pnpm/@ant-design+icons@4.8.3_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/@ant-design/icons/es/icons/UserOutlined';
export default { UserOutlined };
